import React from "react";
import { Modal, Descriptions } from "antd";

export default function FamilyChildModal({ open, onClose, record }) {
  if (!record) return null;

  return (
    <Modal
      title="Family Child Details"
      open={open}
      onCancel={onClose}
      footer={null}
      maskClosable={false}
      keyboard={true}
      destroyOnClose
    >
      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label="Name">
          {record.name}
        </Descriptions.Item>
        <Descriptions.Item label="PAN">
          {record.pan}
        </Descriptions.Item>
        <Descriptions.Item label="Total Investment">
          ₹{Number(record.totals?.total_investment || 0).toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label="Redemption Cost Amount">
          ₹{Number(record.totals?.redemption_cost_amount || 0).toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label="Redemption Actual Amount">
          ₹{Number(record.totals?.redemption_actual_amount || 0).toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label="Remaining Cost Value">
          ₹{Number(record.totals?.remaining_cost_value || 0).toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label="Current Value">
          ₹{Number(record.totals?.current_value || 0).toLocaleString()}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}
